import { FC } from 'react';
import { ShoppingBagIcon } from '@heroicons/react/outline';
import { useForm } from 'react-hook-form';
import {
  classNames,
  quantityInputProps as _quantityInputProps,
} from '../../lib/utils';
import { IProduct } from '../../lib/fetch/products';

interface IAddCartField {
  onAdd: (quantity: number) => void;
  product: IProduct;
}

const AddCartField: FC<IAddCartField> = (props) => {
  const { onAdd = () => {}, product } = props;
  const quantityInputProps = _quantityInputProps(product);
  const { handleSubmit, register } = useForm({
    defaultValues: {
      quantity: quantityInputProps.defaultValue,
    },
  });
  const disabled = quantityInputProps.disabled || !product.attributes.price;
  return (
    <form
      className="flex items-center justify-end"
      onSubmit={handleSubmit(({ quantity }) => {
        !disabled && onAdd(+quantity || 0);
      })}
    >
      <input
        type="number"
        className="mr-2 block w-full w-20 rounded-md border-transparent bg-gray-100 py-2 shadow-sm focus:border-red-500 focus:ring-red-500 sm:text-sm"
        required
        {...quantityInputProps}
        {...register('quantity', {
          required: true,
          min: quantityInputProps.min,
          max: quantityInputProps.max,
          disabled,
          valueAsNumber: true,
        })}
      />
      <button
        type="submit"
        disabled={disabled}
        className={classNames(
          'flex items-center justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-sm font-normal text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2',
          !disabled && 'hover:bg-red-700'
        )}
        style={disabled ? { cursor: 'not-allowed' } : {}}
      >
        <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" />
      </button>
    </form>
  );
};

export default AddCartField;
